<template>
  <div>
    <template v-if="menuSetting.target">
      <v-subheader>配信対象者</v-subheader>
      <v-layout pl-4>
        <v-chip
          v-for="t in menuSetting.target"
          :key="t"
          color="blue"
          small
          outline
        >
          {{ targetText(t) }}
        </v-chip>
      </v-layout>
    </template>
    <template v-if="targetIncludesVisitor">
      <v-subheader>過去訪問期間</v-subheader>
      <v-layout pl-4>{{ periodText }}</v-layout>
    </template>
    <template v-if="targetIncludesVisitor">
      <v-subheader>過去訪問回数</v-subheader>
      <v-layout pl-4>{{ countText }}</v-layout>
    </template>
    <template v-if="!menuSetting.enableRadiusAutomation">
      <v-subheader>精度の低い位置情報</v-subheader>
      <v-layout pl-4>
        <span v-if="menuSetting.useLowQualityLocation || menuSetting.useS2">
          使用する
        </span>
        <span v-else>使用しない</span>
      </v-layout>
    </template>
  </div>
</template>

<script>
import { MenuTargets, TargetVisitorConsts } from '@/models/CampaignOperation'

export default {
  name: 'CampaignModalPageConfirmTarget',
  props: {
    menuSetting: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    minutesAgoText() {
      if (
        this.menuSetting.minutesAgo <
        TargetVisitorConsts.MIN_DAYS * 24 * 60
      ) {
        const hours = Math.floor(this.menuSetting.minutesAgo / 60)
        return `${hours}時間前`
      } else {
        const days = Math.floor(this.menuSetting.minutesAgo / 24 / 60)
        return `${days}日前`
      }
    },
    targetIncludesVisitor() {
      if (!this.menuSetting.target) {
        return true
      }
      return this.menuSetting.target.includes(MenuTargets.VISITOR)
    },
    periodText() {
      if (this.menuSetting.minutesAgo > 0) {
        return `${this.minutesAgoText} 〜 現在`
      } else {
        return '現在'
      }
    },
    countText() {
      return `${this.menuSetting.visitCount} 回以上`
    },
  },
  methods: {
    targetText(target) {
      switch (target) {
        case MenuTargets.VISITOR:
          return '訪問者'
        case MenuTargets.RESIDENT:
          return '居住者'
        default:
          return ''
      }
    },
  },
}
</script>
